import { render, staticRenderFns } from "./AvailableOnlyForCgEliteText.vue?vue&type=template&id=00e8c970&scoped=true"
import script from "./AvailableOnlyForCgEliteText.vue?vue&type=script&lang=js"
export * from "./AvailableOnlyForCgEliteText.vue?vue&type=script&lang=js"
import style0 from "./AvailableOnlyForCgEliteText.vue?vue&type=style&index=0&id=00e8c970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e8c970",
  null
  
)

export default component.exports